import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'has_the_fac_conducted_a_health_and_safety_risk_assessment'

export const dataPointDefinition = {
  retracedId: 'has_the_fac_conducted_a_health_and_safety_risk_assessment',
  name: 'Has the facility conducted a health and safety risk assessment?',
  description:
    'This risk assessment could include topics such as: General Work Environment, Building Safety, Emergency Preparedness Chemicals/Hazardous Substances, Worker Protection, Materials Handling and Storage, Electrical Safety, First Aid/Medical, Contractor Safety, Dormitories, Canteens, etc.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-16',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14320,
  sectionId: '2.2.9.1',
  impactArea: 'Risk Assessment',
  impactAreaId: 'RISK_ASSESSMENT',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
